import types from "./types";

const INITIAL_STATE = {
	client_projects: null,
	client_projectsError: null,
	client_projectsLoading: false,

	//create
	createclient_projects: null,
	createclient_projectsError: null,
	createclient_projectsLoading: false,

	//update
	updateclient_projects: null,
	updateclient_projectsError: null,
	updateclient_projectsLoading: false,

	//delete
	deleteclient_projects: null,
	deleteclient_projectsError: null,
	deleteclient_projectsLoading: false,

	//single item

	singleItem: null,
};

const ClientProjectsReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_CLIENT_PROJECTS_START:
			return {
				...state,
				client_projects: null,
				client_projectsError: null,
				client_projectsLoading: true,
			};
		case types.GET_CLIENT_PROJECTS_SUCCESS:
			return {
				...state,
				client_projects: action.payload,
				client_projectsLoading: false,
			};
		case types.GET_CLIENT_PROJECTS_ERROR:
			return {
				...state,
				client_projectsError: action.payload,
				client_projectsLoading: false,
			};
		case types.GET_CLIENT_PROJECTS_RESET:
			return {
				...state,
				client_projectsError: null,
				client_projectsLoading: false,
			};
		//create

		case types.CREATE_CLIENT_PROJECTS_START:
			return {
				...state,
				createclient_projects: null,
				createclient_projectsError: null,
				createclient_projectsLoading: true,
			};
		case types.CREATE_CLIENT_PROJECTS_SUCCESS:
			return {
				...state,
				createclient_projects: action.payload,
				createclient_projectsLoading: false,
			};
		case types.CREATE_CLIENT_PROJECTS_ERROR:
			return {
				...state,
				createclient_projectsError: action.payload,
				createclient_projectsLoading: false,
			};
		case types.CREATE_CLIENT_PROJECTS_RESET:
			return {
				...state,
				createclient_projectsError: null,
				createclient_projectsLoading: false,
			};
		//delete

		case types.DELETE_CLIENT_PROJECTS_START:
			return {
				...state,
				deleteclient_projects: null,
				deleteclient_projectsError: null,
				deleteclient_projectsLoading: true,
			};
		case types.DELETE_CLIENT_PROJECTS_SUCCESS:
			return {
				...state,
				deleteclient_projects: action.payload,
				deleteclient_projectsLoading: false,
			};
		case types.DELETE_CLIENT_PROJECTS_ERROR:
			return {
				...state,
				deleteclient_projectsError: action.payload,
				deleteclient_projectsLoading: false,
			};
		case types.DELETE_CLIENT_PROJECTS_RESET:
			return {
				...state,
				deleteclient_projects: null,
				deleteclient_projectsError: null,
				deleteclient_projectsLoading: false,
			};

		//update
		case types.UPDATE_CLIENT_PROJECTS_START:
			return {
				...state,
				updateclient_projects: null,
				updateclient_projectsError: null,
				updateclient_projectsLoading: true,
			};
		case types.UPDATE_CLIENT_PROJECTS_SUCCESS:
			return {
				...state,
				updateclient_projects: action.payload,
				updateclient_projectsLoading: false,
			};
		case types.UPDATE_CLIENT_PROJECTS_ERROR:
			return {
				...state,
				updateclient_projectsError: action.payload,
				updateclient_projectsLoading: false,
			};
		case types.UPDATE_CLIENT_PROJECTS_RESET:
			return {
				...state,
				updateclient_projects: null,
				updateclient_projectsError: null,
				updateclient_projectsLoading: false,
			};
		//singleItem
		// case types.SINGLE_CLIENT_PROJECTS_START:
		// 	return {
		// 		...state,
		// 		updateclient_projects: null,
		// 		updateclient_projectsError: null,
		// 		updateclient_projectsLoading: true,
		// 	};
		// case types.SINGLE_CLIENT_PROJECTS_SUCCESS:
		// 	return {
		// 		...state,
		// 		updateclient_projects: action.payload,
		// 		updateclient_projectsLoading: false,
		// 	};
		// case types.SINGLE_CLIENT_PROJECTS_ERROR:
		// 	return {
		// 		...state,
		// 		updateclient_projectsError: action.payload,
		// 		updateclient_projectsLoading: false,
		// 	};
		// case types.SINGLE_CLIENT_PROJECTS_RESET:
		// 	return {
		// 		...state,
		// 		updateclient_projectsError: null,
		// 		updateclient_projectsLoading: false,
		// 	};

		default:
			return { ...state };
	}
};

export default ClientProjectsReducer;
